import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SecurityService } from 'src/app/services/security/security.service';

@Component({
  selector: 'app-select-2fa-method',
  templateUrl: './select-2fa-method.component.html',
  styleUrls: ['./select-2fa-method.component.css']
})
export class Select2faMethodComponent implements OnInit {

  @Input() tempToken: string = '';
  @Input() availableMethods: string[] = [];
  @Input() configuredMethods: any = {}; // Indica qué métodos están configurados
  @Input() phoneNumber: string | null = null;
  @Output() onMethodSelected = new EventEmitter<string>();
  @Output() onSetupRequired = new EventEmitter<string>(); // Nuevo evento para cuando se requiere setup
  @Output() onCancel = new EventEmitter<void>();

  loading = false;
  errors: any[] = [];

  constructor(private securityService: SecurityService) {}

  ngOnInit(): void {}

  async selectMethod(method: string): Promise<void> {
    this.errors = [];
    this.loading = true;

    try {
      // Verificar si el método está configurado
      const isConfigured = this.configuredMethods[method];
      
      if (!isConfigured) {
        // Si NO está configurado, emitir evento de setup requerido
        console.log(`🔧 Método ${method} no configurado - requiere setup`);
        this.onSetupRequired.emit(method);
        this.loading = false;
        return;
      }

      // Si está configurado, proceder con verificación
      if (method === 'sms') {
        // Solicitar envío de código SMS
        await this.securityService.requestSMSCode(this.tempToken);
      }
      
      // Emitir método seleccionado para verificación
      this.onMethodSelected.emit(method);
    } catch (error: any) {
      this.errors = [{ msg: error?.error?.msg || 'Error al procesar la solicitud' }];
      this.loading = false;
    }
  }

  cancel(): void {
    this.onCancel.emit();
  }
}
